declare global {
  interface Window {
    handleMapInit: (...args: any[]) => void;
  }
}

export default defineNuxtPlugin(() => {
  const {
    public: { googleApiKey, googleMapsLibraries },
  } = useRuntimeConfig();
  const url = `https://maps.googleapis.com/maps/api/js?key=${googleApiKey}&libraries=${googleMapsLibraries}&callback=handleMapInit&loading=async`;
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = url;
  script.defer = true;
  script.async = true;

  document.head.appendChild(script);

  const hasLoaded = ref(false);

  window.handleMapInit = () => {
    const { $googleMaps } = useNuxtApp();
    if ($googleMaps) {
      $googleMaps.hasLoaded.value = true;
    }
  };

  return {
    provide: {
      googleMaps: { hasLoaded },
    },
  };
});
